import { render, staticRenderFns } from "./IndexPageReceivingKindsSection.vue?vue&type=template&id=6ff49be0&"
import script from "./IndexPageReceivingKindsSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageReceivingKindsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports